import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const TelegramIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 14, height = 12, stroke = "#1677FF", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 14 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M9 4.66699L6.33333 7.33366L10.3333 11.3337L13 0.666992L1 5.33366L3.66667 6.66699L5 10.667L7 8.00033"
          stroke={stroke}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
